(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9528],{

/***/ 58577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
}), 'Business'));

/***/ }),

/***/ 41396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckCircle'));

/***/ }),

/***/ 7354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"
}), 'Cloud'));

/***/ }),

/***/ 62111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
}), 'Public'));

/***/ }),

/***/ 72304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
}), 'Security'));

/***/ }),

/***/ 67990:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/baremetal",
      function () {
        return __webpack_require__(33658);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41120);
/* harmony import */ var _styles_jss_bbhost_pages_landingPage_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(538);
/* harmony import */ var _styles_jss_bbhost_pages_landingPageSections_teamStyle_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57180);








var styles = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _styles_jss_bbhost_pages_landingPage_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _styles_jss_bbhost_pages_landingPageSections_teamStyle_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z), {
    main: {
        background: "#f1f5f8",
        position: "relative",
        zIndex: "3",
        paddingTop: "30px"
    }
});
var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles);
function Loading(props) {
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classes.section,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
            className: classes.title,
            children: "Carregando...."
        })
    });
}


/***/ }),

/***/ 33658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ BareMetal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/core/index.mjs + 1 modules
var core = __webpack_require__(81758);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Public.js
var Public = __webpack_require__(62111);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/CheckCircle.js
var CheckCircle = __webpack_require__(41396);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Cloud.js
var Cloud = __webpack_require__(7354);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Security.js
var Security = __webpack_require__(72304);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(63786);
;// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/ContactSupport.js


/* harmony default export */ var ContactSupport = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M11.5 2C6.81 2 3 5.81 3 10.5S6.81 19 11.5 19h.5v3c4.86-2.34 8-7 8-11.5C20 5.81 16.19 2 11.5 2zm1 14.5h-2v-2h2v2zm0-3.5h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5z"
}), 'ContactSupport'));
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Business.js
var Business = __webpack_require__(58577);
;// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/BlurCircular.js


/* harmony default export */ var BlurCircular = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-3-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm3 6c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm2-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
}), 'BlurCircular'));
;// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/BlurOn.js


/* harmony default export */ var BlurOn = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
}), 'BlurOn'));
// EXTERNAL MODULE: ./components/Functions/Loading.js
var Loading = __webpack_require__(24552);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(79895);
// EXTERNAL MODULE: ./styles/jss/bbhost/pages/landingPage.js
var landingPage = __webpack_require__(538);
// EXTERNAL MODULE: ./pages-sections/HeaderSection.js + 3 modules
var HeaderSection = __webpack_require__(75994);
// EXTERNAL MODULE: ./lang/lang.js + 3 modules
var lang = __webpack_require__(34426);
// EXTERNAL MODULE: ./configs/index.js + 16 modules
var configs = __webpack_require__(91856);
;// CONCATENATED MODULE: ./pages/baremetal.js









// @material-ui/core components




var Footer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1800), __webpack_require__.e(4817), __webpack_require__.e(5121), __webpack_require__.e(1788), __webpack_require__.e(7298)]).then(__webpack_require__.bind(__webpack_require__, 37298));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37298)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
    }
});
var Badge = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1511).then(__webpack_require__.bind(__webpack_require__, 1511));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1511)
            ];
        }
    }
});
var Accordions = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3585).then(__webpack_require__.bind(__webpack_require__, 73585));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73585)
            ];
        }
    }
});
var InfoArea = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6831).then(__webpack_require__.bind(__webpack_require__, 5323));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5323)
            ];
        }
    }
});
var InfoAreaLink = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1800), __webpack_require__.e(8743)]).then(__webpack_require__.bind(__webpack_require__, 98743));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98743)
            ];
        }
    }
});
var NavPills = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9331), __webpack_require__.e(2968), __webpack_require__.e(3507)]).then(__webpack_require__.bind(__webpack_require__, 3507));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3507)
            ];
        }
    }
});
var GridContainer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4041).then(__webpack_require__.bind(__webpack_require__, 64041));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64041)
            ];
        }
    },
    ssr: true
});
var GridItem = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6680).then(__webpack_require__.bind(__webpack_require__, 96680));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96680)
            ];
        }
    }
});
var ProductTabs = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9331), __webpack_require__.e(2514)]).then(__webpack_require__.bind(__webpack_require__, 21183));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21183)
            ];
        }
    },
    ssr: true
});

var styles = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, landingPage/* default */.Z), {
    main: {
        background: "#f1f5f8",
        position: "relative",
        zIndex: "3",
        paddingTop: "30px"
    },
    section: {
        textAlign: "center"
    },
    textCenter: {
        textAlign: "center"
    },
    title: {
        color: "#3C4858",
        margin: "1.75rem 0 0.875rem",
        textDecoration: "none",
        fontWeight: "700",
        fontFamily: '"Roboto Slab", "Times New Roman", serif'
    }
});
// Sections for this page

var ProductSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4817), __webpack_require__.e(628), __webpack_require__.e(8117)]).then(__webpack_require__.bind(__webpack_require__, 28117));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28117)
            ];
        }
    },
    ssr: true,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
    }
});
var SEO = {
    title: "BB Host - Bare Metal",
    description: "Tenha seu pr\xf3prio dedicado utilizando todos os recursos, sem compartilhamento!",
    url: "https://www.bbhost.com.br/baremetal",
    type: "website",
    languageAlternates: [
        {
            hrefLang: "en",
            href: "https://www.bbhost.com.br/en/baremetal"
        },
        {
            hrefLang: "es",
            href: "https://www.bbhost.com.br/es/baremetal"
        }
    ]
};
var useStyles = (0,makeStyles/* default */.Z)(styles);


var fetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    });
};
var __N_SSG = true;
function BareMetal(props) {
    var classes = useStyles();
    var ref = (0,router.useRouter)(), locale = ref.locale, defaultLocale = ref.defaultLocale;
    var aggregateOffer = props.aggregateOffer;
    var products_tab = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var products_spot_tab = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var productsTab = /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
    var faqsTabs = [
        {
            tabButton: (0,lang/* trans */.d)("products::faqs.tabs.traffic"),
            tabIcon: Public/* default */.Z,
            tabContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.section,
                style: {
                    background: "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: classes.title,
                        children: (0,lang/* trans */.d)("products::faqs.tabs.traffic")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridContainer, {
                        justifyContent: "center",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                                xs: 12,
                                sm: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoArea, {
                                    iconColor: "info",
                                    icon: CheckCircle/* default */.Z,
                                    title: "",
                                    description: "Traf\xe9go de download (entrada) gratuito."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                                xs: 12,
                                sm: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoArea, {
                                    iconColor: "info",
                                    icon: CheckCircle/* default */.Z,
                                    title: "",
                                    description: "30TB de traf\xe9go de upload (sa\xedda) inclusos em todos os servi\xe7os baremetal Brasil."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                                xs: 12,
                                sm: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoArea, {
                                    iconColor: "info",
                                    icon: CheckCircle/* default */.Z,
                                    title: "",
                                    description: "Pacotes de tr\xe1fego vendidos em incrementos de 10TB. O custo por TB de tr\xe1fego \xe9 de R$18,00 por m\xeas."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                                xs: 12,
                                sm: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoArea, {
                                    iconColor: "info",
                                    icon: CheckCircle/* default */.Z,
                                    title: "",
                                    description: "Traf\xe9go calculado com base no uso dos \xfaltimos 30 dias."
                                })
                            })
                        ]
                    })
                ]
            })
        },
        {
            tabButton: (0,lang/* trans */.d)("products::faqs.tabs.ips"),
            tabIcon: Cloud/* default */.Z,
            tabContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.section,
                style: {
                    background: "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: classes.title,
                        children: (0,lang/* trans */.d)("products::faqs.tabs.ips")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridContainer, {
                        justifyContent: "center",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                                xs: 12,
                                sm: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoArea, {
                                    iconColor: "info",
                                    icon: CheckCircle/* default */.Z,
                                    title: "",
                                    description: "IPs adicionais tem custo de R$20,00 mensais por IP, limitados a 4 IPs adicionais por servi\xe7o."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                                xs: 12,
                                sm: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoArea, {
                                    iconColor: "info",
                                    icon: CheckCircle/* default */.Z,
                                    title: "",
                                    description: "Tenha seu pr\xf3prio bloco sendo o m\xednimo /29 (5 ips), custando R$16,00 por ip mensal."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                                xs: 12,
                                sm: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoArea, {
                                    iconColor: "info",
                                    icon: CheckCircle/* default */.Z,
                                    title: "",
                                    description: "Utilize seu pr\xf3prio bloco de IP (/24 ou maior), na modalidade BYO-IP por R$1.000,00 mensais (por /24)."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                                xs: 12,
                                sm: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoArea, {
                                    iconColor: "info",
                                    icon: CheckCircle/* default */.Z,
                                    title: "",
                                    description: "IPv6 gratuito. 1 IPv6 (/128) para cada IP adicional ou 1 bloco IPv6 /48 no caso da contrata\xe7\xe3o de blocos IPv4."
                                })
                            })
                        ]
                    })
                ]
            })
        },
        {
            tabButton: (0,lang/* trans */.d)("products::faqs.tabs.mitigation"),
            tabIcon: Security/* default */.Z,
            tabContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.section,
                style: {
                    background: "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: classes.title,
                        children: (0,lang/* trans */.d)("products::faqs.tabs.mitigation")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: classes.title,
                        children: "Global Mitigation AlwaysOn"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridContainer, {
                        justifyContent: "center",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                                xs: 12,
                                sm: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoArea, {
                                    iconColor: "info",
                                    icon: CheckCircle/* default */.Z,
                                    title: "",
                                    description: "Mitiga\xe7\xe3o de 248 Tbps inclusa sem custos adicionais, sendo a mesma sempre ativa."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                                xs: 12,
                                sm: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoArea, {
                                    iconColor: "info",
                                    icon: CheckCircle/* default */.Z,
                                    title: "",
                                    description: "Notifica\xe7\xe3o por e-mail de ataques recebidos."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: classes.title,
                        children: "DDoS Pro"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridContainer, {
                        justifyContent: "center",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                                xs: 12,
                                sm: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoArea, {
                                    iconColor: "info",
                                    icon: CheckCircle/* default */.Z,
                                    title: "",
                                    description: "DDoS Pro para aplica\xe7\xf5es espec\xedficas com perfil de v\xe1rios jogos e aplica\xe7\xf5es j\xe1 existentes, caso n\xe3o exista podemos criar um perfil para sua aplica\xe7\xe3o."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                                xs: 12,
                                sm: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoArea, {
                                    iconColor: "info",
                                    icon: CheckCircle/* default */.Z,
                                    title: "",
                                    description: "Custo de R$300,00 por ip no DDoS Pro, podendo utilizar portas ilimitadas."
                                })
                            })
                        ]
                    })
                ]
            })
        },
        {
            tabButton: (0,lang/* trans */.d)("products::faqs.tabs.support"),
            tabIcon: ContactSupport,
            tabContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.section,
                style: {
                    background: "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: classes.title,
                        children: (0,lang/* trans */.d)("products::faqs.tabs.support")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridContainer, {
                        justifyContent: "center",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                                xs: 12,
                                sm: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoArea, {
                                    iconColor: "info",
                                    icon: CheckCircle/* default */.Z,
                                    title: "",
                                    description: "Suporte 24/7 via ticket, tenha atendimento personalizado conforme sua necessidade."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                                xs: 12,
                                sm: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoArea, {
                                    iconColor: "info",
                                    icon: CheckCircle/* default */.Z,
                                    title: "",
                                    description: "Suporte Premium com SLA reduzido, tenha um canal de comunica\xe7\xe3o diretamente com o suporte n\xedvel 2 e engenharia de redes."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                                xs: 12,
                                sm: 12,
                                md: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoArea, {
                                    iconColor: "info",
                                    icon: CheckCircle/* default */.Z,
                                    style: {
                                        maxWidth: "90%"
                                    },
                                    title: "",
                                    description: "Suporte discord e WhatsApp para maior proximidade com o atendente. Caso queira marcar uma reuni\xe3o em nosso discord, entre em contato para agendar."
                                })
                            })
                        ]
                    })
                ]
            })
        }
    ];
    var highlights = configs/* BAREMETAL_FAQS.highlights.map */.Gc.highlights.map(function(highlight, key) {
        var highlight_icon = Business/* default */.Z;
        if (highlight.icon == "Business") {
            highlight_icon = Business/* default */.Z;
        }
        if (highlight.icon == "Security") {
            highlight_icon = Security/* default */.Z;
        }
        if (highlight.icon == "Public") {
            highlight_icon = Public/* default */.Z;
        }
        if (typeof highlight.text === "object") {
            highlight.text = (0,lang/* getLangFromObj */.x)(highlight.text);
        }
        if (typeof highlight.subText === "object") {
            highlight.subText = (0,lang/* getLangFromObj */.x)(highlight.subText);
        }
        if (highlight.more_link !== undefined) {
            if (typeof highlight.more_link.text === "object") {
                highlight.more_link.text = (0,lang/* getLangFromObj */.x)(highlight.more_link.text);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                xs: 12,
                sm: 12,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoAreaLink, {
                    iconColor: highlight.icon_color,
                    icon: highlight_icon,
                    title: highlight.text,
                    description: highlight.subText,
                    link: highlight.more_link
                })
            }, key);
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
            xs: 12,
            sm: 12,
            md: 4,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoArea, {
                iconColor: highlight.icon_color,
                icon: highlight_icon,
                title: highlight.text,
                description: highlight.subText
            })
        }, key);
    });
    var ref1 = (0,core/* default */.ZP)("https://api-frontend-site.bbhost.com.br/products-baremetal", fetcher), dataBaremetal = ref1.data;
    var ref2 = (0,core/* default */.ZP)("https://api-frontend-site.bbhost.com.br/products-baremetal-spot", fetcher), dataBaremetalSpot = ref2.data;
    if (dataBaremetal) {
        products_tab = /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSection, {
            name: "baremetal",
            products: dataBaremetal.products,
            out_of_stock: dataBaremetal.outStockAll,
            locale: {
                locale: locale,
                defaultLocale: defaultLocale
            },
            update: true
        });
    }
    if (dataBaremetalSpot) {
        products_spot_tab = /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSection, {
            name: "baremetal",
            products: dataBaremetalSpot.products,
            out_of_stock: dataBaremetalSpot.outStockAll,
            locale: {
                locale: locale,
                defaultLocale: defaultLocale
            },
            spots: true,
            update: true
        });
    }
    if (dataBaremetal && dataBaremetalSpot) {
        productsTab = /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTabs, {
            headerColor: "success",
            tabs: [
                {
                    tabName: "Principal",
                    tabIcon: BlurCircular,
                    tabContent: products_tab
                },
                {
                    tabName: "Spot",
                    tabIcon: BlurOn,
                    tabContent: products_spot_tab
                }
            ],
            defaultValue: 0,
            tabSyle: {
                variant: "scrollable",
                scrollButtons: "auto",
                "aria-label": "scrollable auto tabs example"
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                openGraph: {
                    type: SEO.type,
                    url: SEO.url,
                    title: SEO.title,
                    description: SEO.description,
                    images: [
                        {
                            url: "https://cdn.bbhost.com.br/images/bg/capa_fundo_dedicado.png",
                            width: 800,
                            height: 600,
                            alt: SEO.description
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* ProductJsonLd */.Qb, {
                productName: "Baremetal",
                images: [],
                description: SEO.description,
                aggregateRating: {
                    ratingValue: "5.0",
                    reviewCount: "200"
                },
                aggregateOffer: aggregateOffer
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSection/* default */.Z, {
                        name: "baremetal",
                        seo: SEO
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()(classes.main, classes.mainRaised),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.container,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.section,
                                    children: productsTab
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridContainer, {
                                    justifyContent: "center",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                                            xs: 12,
                                            sm: 12,
                                            md: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                                                elevation: 10,
                                                style: {
                                                    marginBottom: "15px",
                                                    padding: "10px"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavPills, {
                                                    color: "info",
                                                    tabs: faqsTabs,
                                                    alignCenter: true,
                                                    horizontal: {
                                                        tabsGrid: {
                                                            xs: 12,
                                                            sm: 2,
                                                            md: 2
                                                        },
                                                        contentGrid: {
                                                            xs: 12,
                                                            sm: 10,
                                                            md: 10
                                                        }
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                                            xs: 12,
                                            sm: 12,
                                            md: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridContainer, {
                                                justifyContent: "center",
                                                alignItems: "center",
                                                children: highlights
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridItem, {
                                            xs: 12,
                                            sm: 12,
                                            md: 12,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    className: classes.textCenter,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                                                        color: "info",
                                                        children: (0,lang/* trans */.d)("products::faqs.title")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GridContainer, {
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridItem, {
                                                        xs: 12,
                                                        sm: 12,
                                                        md: 12,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordions, {
                                                            itens: configs/* BAREMETAL_FAQS.list */.Gc.list
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
                ]
            })
        ]
    });
}


/***/ }),

/***/ 57180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21086);
/* harmony import */ var _styles_jss_bbhost_imagesStyles_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89395);




var teamStyle = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    section: {
        padding: "20px 0",
        textAlign: "center"
    },
    title: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .title */ .TN), {
        marginBottom: "1rem",
        marginTop: "30px",
        minHeight: "32px",
        textDecoration: "none"
    })
}, _styles_jss_bbhost_imagesStyles_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
    itemGrid: {
        marginLeft: "auto",
        marginRight: "auto"
    },
    cardTitle: _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .cardTitle */ .X5,
    smallTitle: {
        color: "#6c757d"
    },
    description: {
        color: "#999"
    },
    justifyCenter: {
        justifyContent: "center !important"
    },
    socials: {
        marginTop: "0",
        width: "100%",
        transform: "none",
        left: "0",
        top: "0",
        height: "100%",
        lineHeight: "41px",
        fontSize: "20px",
        color: "#999"
    },
    margin5: {
        margin: "5px"
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (teamStyle);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4888,1758,8653,9774,2888,179], function() { return __webpack_exec__(67990); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);